import React, { useState, useRef } from "react";
import { Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import apiClient from "./http.service"; 

export default function ImageUpload({
    label = "Image",
    value,
    onChange,
    uploadEndpoint,
    error
}) {
    const [uploading, setUploading] = useState(false);
    const fileInputRef = useRef();

    const handleUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setUploading(true);
        const formDataObj = new FormData();
        formDataObj.append("image", file);

        try {
            const response = await apiClient.post(
                uploadEndpoint,
                formDataObj,
                { headers: { "Content-Type": "multipart/form-data" } }
            );
            const uploadedUrl = response?.data?.data?.data?.file || response?.data?.file;

            onChange(uploadedUrl);
            toast.success("Image uploaded successfully!");
        } catch (error) {
            toast.error("Image upload failed");
            console.error(error);
        } finally {
            setUploading(false);
            if (fileInputRef.current) fileInputRef.current.value = "";
        }
    };

    return (
        <div className="w-100">
            {label && <Form.Label className="fw-bold">{label}</Form.Label>}
            <div className="d-flex align-items-center gap-3">
                <div
                    className={`border rounded d-flex align-items-center justify-content-center bg-light ${error ? "border-danger" : ""}`}
                    style={{ width: 80, height: 80, overflow: "hidden" }}
                >
                    {value ? (
                        <img
                            src={value}
                            alt="Preview"
                            style={{ width: "100%", height: "100%", objectFit: "cover" }}
                        />
                    ) : (
                        <span className="text-muted small text-center px-1">No Image</span>
                    )}
                </div>
                <div className="d-flex flex-column">
                    <input
                        type="file"
                        accept="image/*"
                        hidden
                        ref={fileInputRef}
                        onChange={handleUpload}
                    />
                    <Button
                        variant="outline-primary ml-2"
                        size="sm"
                        onClick={() => fileInputRef.current.click()}
                        disabled={uploading}
                    >
                        {uploading ? (
                            <>
                                <span className="spinner-border spinner-border-sm mr-1"></span>
                                Uploading...
                            </>
                        ) : (
                            "Choose Image"
                        )}
                    </Button>
                    {error && <small className="text-danger mt-1">{error}</small>}
                </div>
            </div>
        </div>
    );
}